<!-- <dashboardnav> -->
<!-- <div class="pink_box"></div>
<div class="green_box"></div> -->
<!-- <router-outlet>
</router-outlet> -->

<!-- <dashboardnav> -->

<!-- <dashboardnav >
    <router-outlet></router-outlet>
  </dashboardnav> -->

<div *ngIf="isHome">
  <router-outlet></router-outlet>
</div>

<div *ngIf="!isHome">
  <dashboardnav>
    <!-- <ngx-charts-pie-chart
      [view]="view"
      [scheme]="colorScheme"
      [results]="single"
      [gradient]="gradient"
      [legend]="showLegend"
      [legendPosition]="legendPosition"
      [labels]="showLabels"
      [doughnut]="isDoughnut"
      (select)="onSelect($event)"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)"
    >
    </ngx-charts-pie-chart> -->
    <router-outlet></router-outlet>
  </dashboardnav>
</div>
